
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton } from '@/components';
import { useLiveopsMilestoneList } from '@/modules/liveops/milestone/model/list';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import MilestoneTable from '@/modules/liveops/milestone/view/table.vue';

export default defineComponent({
    name: 'LiveopsMilestoneList',
    components: { AppButton, AppCard, MilestoneTable },
    setup() {
        const { list, total, fetchList, itemInfo, actions } = useLiveopsMilestoneList();

        onMounted(() => fetchList());

        return { list, total, fetchList, itemInfo, actions, ROUTE_NAME_LIVEOPS };
    }
});
